<template>
	<NewHeader v-if="checkUrls.includes(currentPath)" />
	<slot></slot>
	<NewFooter v-if="checkUrls.includes(currentPath)" />
</template>

<script>
import Urls from '../../../assets/entry/urlpaths';
import Header from '../Components/HeaderV2.vue';
import Footer from '../Components/FooterV2.vue';
export default {
	name: 'HFW',
	components: {
		NewFooter: Footer,
		NewHeader: Header,
	},
	data: () => ({
		checkUrls: Urls,
		currentPath: window.location.pathname,
	}),
	mounted() {
		this.$emit('isNewUi', this.checkUrls.includes(this.currentPath));
	},
};
</script>
